import React from 'react';

type HeaderProps = {
	title: string;
	subtitle?: string;
	iconLeft?: React.ReactNode;
	iconLeftOnClick?: () => void;
	iconRight?: React.ReactNode;
	iconRightOnClick?: () => void;
};

export const Header = ({
	title,
	subtitle,
	iconLeft,
	iconLeftOnClick,
	iconRight,
	iconRightOnClick
}: HeaderProps) => {

	const isIconLeftValid = iconLeft && !(React.isValidElement(iconLeft) && iconLeft.type === React.Fragment);

	return (
		<header className='bg-tablz-dark-gray-2 flex gap-3 p-3 w-full justify-between items-center border-b border-tablz-med-gray-4'>
			{/* Creating two equally sized buttons on each side so the text always stays centered within the flexbox */}
			<div
				className={`${!isIconLeftValid && 'opacity-0 cursor-none'}`}
				onClick={iconLeftOnClick}
			>
				{isIconLeftValid ? iconLeft : iconRight}
			</div>

			<div className='flex flex-col items-center'>
				{subtitle && <span className="text-center font-poppins text-base text-tablz-text-gray-3">{subtitle}</span>}
				<span className="text-white text-center font-lora text-2xl font-medium">{title}</span>
			</div>

			<div onClick={iconRightOnClick}>
				{iconRight}
			</div>
		</header>
	);
};
